<template>
  <div
    class="button-default"
    :class="[
      arrow ? 'button-default--arrow-' + arrow : null,
      theme ? 'button-default--theme-' + theme + (negative ? '-negative' : '') : null,
      {
        'button-default--border': border,
        'button-default--pointer-absolute': pointerAbsolute,
        'button-default--no-label': (!label || label === '') && !$slots.default
      },
      reverse ? 'reverse' : ''
    ]"
  >
    <div
      :is="component.name"
      class="button-default__wrapper"
      v-bind="component.props"
    >
      <span
        v-if="(label || $slots.default)"
        class="button-default__label"
      >
        <slot>{{ label }}</slot>
      </span>

      <span
        v-if="arrow"
        class="button-default__arrow"
      >
        <svg
          width="13"
          height="13"
          viewBox="0 0 13 13"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          class="button-default__arrow-shape"
        >
          <!-- eslint-disable max-len -->
          <path d="M5.60668 1.34605L10.1863 5.90005L0.500244 5.90005L0.500244 7.10004L10.1863 7.10004L5.60668 11.654L6.45855 12.5001L12.5002 6.50004L6.45855 0.500061L5.60668 1.34605Z" />
        </svg>
      </span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    to: { type: [String, Object], default: null },
    label: { type: String, default: null },
    arrow: { type: String, default: null },
    theme: { type: String, default: null },
    border: { type: Boolean, default: false },
    negative: { type: Boolean, default: false },
    pointerAbsolute: { type: Boolean, default: false },
    reverse: { type: Boolean, default: false },
  },

  computed: {
    isExternalLink() {
      return (!(this.to instanceof Object) && this.to.match(/^http[s]?:\/\//) !== null);
    },
    component() {
      if (!this.to) {
        return {
          name: 'div',
          props: { },
        };
      }

      if (this.isExternalLink) {
        return {
          name: 'a',
          props: { href: this.to, target: '_blank' },
        };
      }

      return {
        name: 'router-link',
        props: { to: this.to },
      };
    },
  },
};
</script>

<style lang="stylus">
.button-default {
  $height = 45px;

  cursor: pointer;
  -webkit-tap-highlight-color: rgba(255, 255, 255, 0);

  &__wrapper {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    color: $cl-white;

    .button-default--pointer-absolute & {
      &:before {
        content: '';
        position: absolute;
        top:    0;
        right:  0;
        bottom: 0;
        left:   0;
        z-index: 1;

        border-radius: 10px;
      }
    }

    .reverse & {
      flex-direction: row-reverse;
      justify-content: flex-end;
    }
  }

  &__label {
    @extend $typo-button-default;

    flex-grow: 1;
    padding: 15.5px 18px;

    text-transform: uppercase;
    text-align: center;

    background-color: $cl-green;
    border-radius: 25px;

    +desktop() {
      flex-grow: 0;
    }
  }

  &__arrow {
    position: relative;

    flex: 0 0 auto;
    display: block;
    width: 41px;
    height: @width;
    margin-left: 5px;

    background-color: $cl-green;
    border-radius: 25px;

    +desktop() {
      width: 45px;
      height: @width;
    }

    .button-default--no-label & { margin: 0; }
    .button-default--arrow-top & { transform: rotate(-90deg); }
    .button-default--arrow-top-right & { transform: rotate(-45deg); }
    .button-default--arrow-right & { transform: rotate(0); }
    .button-default--arrow-bottom-right & { transform: rotate(45deg); }
    .button-default--arrow-bottom & { transform: rotate(90deg); }
    .button-default--arrow-bottom-left & { transform: rotate(135deg); }
    .button-default--arrow-left & { transform: rotate(180deg); }
    .button-default--arrow-top-left & { transform: rotate(225deg); }
  }

  &__label,
  &__arrow {
    .button-default--theme-green & { background-color: $cl-green; }
    .button-default--theme-purple & { background-color: $cl-purple; }
    .button-default--theme-orange & { background-color: $cl-orange; }
    .button-default--theme-green-negative & {
      color: $cl-green;
      background-color: $cl-white;
    }
    .button-default--theme-purple-negative & {
      color: $cl-purple;
      background-color: $cl-white;
    }
    .button-default--theme-orange-negative & {
      color: $cl-orange;
      background-color: $cl-white;
    }

    .button-default--border & {
      border: 1px solid currentColor;
    }
  }

  &__arrow-shape {
    position: absolute;
    top: 50%;
    left: @top;

    fill: currentColor;
    transform: translate(-50%, -50%);

    +pointer-device() {
      .button-default:hover & {
        animation: jump 0.65s $ease-in-out-cubic infinite alternate;
      }
    }
  }

  @keyframes jump {
    0%: { transform: translate(-50%, -50%); }
    50% { transform: translate(-15%, -50%); }
    100% { transform: translate(-65%, -50%); }
  }
}
</style>
